// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__MYc3_","additionalInfo":"AgreementModal_additionalInfo__20yvh"};